import React from 'react';
const UiNotificationContext = React.createContext();
export default UiNotificationContext;
